<template>
    <div>
        <b-modal id="user-edit" title="Edit User" :hide-footer="hideFooter">
            <form>
                <div class="form-group">
                    <label for="#cmpName">User Email:</label>
                    <input class="form-control" type="text" placeholder="Ex: Soccer" required="required" v-model="user.email">
                </div>
                <div class="form-group">
                    <label for="#cmpCode">User permission:</label>
                    <input class="form-control" type="text" placeholder="Ex: 2" required="required" v-model="user.permission">
                </div>
                <div class="form-group">
                    <label for="#bkmDescription">Password:</label>
                    <input class="form-control" type="text" placeholder="Ex: incorrect" required="required" v-model="password">
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary form-control" @click.prevent="updateUser">Update</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Bus } from '@/main'
export default {
  data () {
    return {
      hideFooter: true,
      user: '',
      password: ''
    }
  },
  methods: {
    updateUser () {
      if (this.user.email && this.user.permission) {
        const patch = this.password ? { email: this.user.email, password: this.password, permission: this.user.permission } : { email: this.user.email, permission: this.user.permission }
        this.$http.patch(`${this.$api_url}/users/edit/` + this.user._id, patch).then((success, error) => {
          if (success) {
            Bus.$emit('userUpdated', success.data)
            this.email = ''
            this.permission = ''
            this.password = ''

            this.$bvModal.hide('user-edit')
          }
          if (error) {
            this.$bvModal.hide('user-edit')
            alert('Something wrong just happened!')
          }
        })
      } else {
      }
    }
  },
  created () {
    Bus.$on('editUser', (userData) => {
      this.user = userData
    })
  },
  beforeDestroy () {
    Bus.$off('editUser')
  }
}
</script>
<style scoped>
</style>
